import moment from "moment-timezone";

/**
 * Formats a UTC datetime string with inline timezone abbreviation and UTC offset.
 *
 * Example output: "08 Jul 2026 02:30 PM IST (UTC +05:30)"
 *
 * @param {string|null} dt - UTC datetime string
 * @param {string} tzString - IANA timezone string e.g. "Asia/Kolkata"
 * @param {string} [format="DD MMM YYYY hh:mm A z [(UTC ]Z[)]"]
 * @returns {string|null}
 */
const formatDateTimeWithTz = (dt, tzString, format = "DD MMM YYYY hh:mm A z [(UTC ]Z[)]") => {
  if (!dt) return null;
  const tz = tzString || "UTC";
  return moment.utc(dt).tz(tz).format(format);
};

export { formatDateTimeWithTz };
